import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/refeicao`;
export const createRefeicao = async (refeicao) => {
  return await axios.post(`${httpUrl}/create`, refeicao).then((response) => response);
};

export const getListaRefeicoes = async (filtros) => {
  return await axios.post(`${httpUrl}/listByFiltros`, filtros).then((response) => response);
};

export const getRefeicaoById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteRefeicaoById = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
